<div
  class="hollow-circle"
  [style.width]="calcCircleSize(radius, borderWidth)"
  [style.height]="calcCircleSize(radius, borderWidth)"
  [style.borderRadius]="'50%'"
  [style.background]="generateGradient(radius, borderWidth)"
></div>
